module.exports = __webpack_public_path__ + "static/media/image_1.fe292b90.png";